module.exports = __webpack_public_path__ + "assets/u60.7e52918f.svg";